document.addEventListener("DOMContentLoaded", function() {
  const navItems = document.querySelectorAll(".stickyFilter-list-item");
  const stickyFilter = document.querySelector(".stickyFilter-section");
  if (!stickyFilter) return;

  let stickyOffsetTop = stickyFilter.offsetTop;

// Get all product block sections in order
  const productSections = document.querySelectorAll('.shopify-section.shopAll-productBlock-section');

  navItems.forEach((item, index) => {
    item.addEventListener("click", function() {

// Remove 'selected' class from all items and add to the clicked item
      navItems.forEach((nav) => nav.classList.remove("selected"));
      item.classList.add("selected");

    const labelEl = item.querySelector('.r-button__content__text');
    const filterText = (labelEl ? labelEl.textContent : item.textContent).trim().toLowerCase();
    const targetValue = filterText;
    const allHeadings = document.querySelectorAll('section.shopify-section.shopAll-productBlock-section > h1');

// Adding a logic to let the team select the section by the sticky filter label
    if (filterText) {
      const anchorSelector = `.shopall-product-block-anchor[data-filter-label="${filterText}"]`;
      const targetAnchor = document.querySelector(anchorSelector);
      if (targetAnchor) {
        const targetSection = targetAnchor.closest('.shopify-section.shopAll-productBlock-section') || targetAnchor;
        targetSection.scrollIntoView({behavior: "smooth", block: "start"});
        return;
      }
    }

// Handle special cases
      if (filterText === "all" || filterText === "shop all") {
        window.scrollTo({top: 0, behavior: "smooth"});
        return;
      }

      if (filterText.includes("holiday")) {
        const holidaySection = document.querySelector(".shopall-product-block-holiday-banner");
        if (holidaySection) {
          holidaySection.scrollIntoView({behavior: "smooth"});
          return;
        }
      }
      const targetHeading = Array.from(allHeadings).find(h1 => h1.textContent.toLowerCase().includes(`${targetValue}`));

// const targetSection = document.querySelector(`[header*="${targetValue} Blends"]`);
      if (targetHeading) {
        targetHeading.scrollIntoView({behavior: "smooth"});
        return;
      }

// Map filter index to section index
// First filter item (index 0) is "All", so sections start at index 1
      const sectionIndex = index - 1;

      if (sectionIndex >= 0 && sectionIndex < productSections.length) {
        productSections[sectionIndex].scrollIntoView({behavior: "smooth", block: "start"});
      }
    });
  });


  const SCROLL_BUFFER = 8;
  const BOTTOM_LOCK_OFFSET = 4;

  let lastScrollTop = window.scrollY || document.documentElement.scrollTop;
  let ticking = false;

  const refreshStickyOffset = function() {
    stickyOffsetTop = stickyFilter.offsetTop;
  };

  const updateStickyState = function() {
    const currentScrollTop = window.scrollY || document.documentElement.scrollTop;
    const maxScrollTop = document.documentElement.scrollHeight - window.innerHeight;
    const atBottom = currentScrollTop >= maxScrollTop - BOTTOM_LOCK_OFFSET;
    const delta = currentScrollTop - lastScrollTop;
    const stickyFilterBottom = stickyOffsetTop + stickyFilter.offsetHeight;

    if (currentScrollTop <= stickyOffsetTop) {
      stickyFilter.classList.remove("sticky", "navHidden");
      lastScrollTop = currentScrollTop;
      return;
    }

    if (atBottom || delta < -SCROLL_BUFFER) {
      stickyFilter.classList.remove("navHidden");
      stickyFilter.classList.add("sticky");
    } else if (delta > SCROLL_BUFFER && currentScrollTop > stickyFilterBottom) {
      stickyFilter.classList.add("navHidden");
      stickyFilter.classList.remove("sticky");
    }

    if (Math.abs(delta) > SCROLL_BUFFER) {
      lastScrollTop = currentScrollTop;
    }
  };

  const handleScroll = function() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function() {
      updateStickyState();
      ticking = false;
    });
  };

  window.addEventListener("scroll", handleScroll, {passive: true});
  window.addEventListener("resize", refreshStickyOffset);
  window.addEventListener("load", refreshStickyOffset);
});

// Align an anchored product block to the top of the viewport when it is linked to
// directly (e.g. /pages/shop-all#feel-alive-mug). We re-run this on load so the
// position is correct after lazy-loaded images above the target have settled (the
// native hash jump fires too early and lands low once those images push the layout down).
(function () {
  function scrollHashTargetToTop(smooth) {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var id = hash.slice(1);
    var target = document.getElementById(id);
    if (!target) {
      try {
        target = document.getElementById(decodeURIComponent(id));
      } catch (e) {
        target = null;
      }
    }
    if (!target) return;

    target.scrollIntoView({behavior: smooth ? "smooth" : "auto", block: "start"});
  }

  // Direct load of a deep link: wait for images so the layout is settled before scrolling.
  window.addEventListener("load", function () {
    scrollHashTargetToTop(false);
  });

  // Same-page anchor changes.
  window.addEventListener("hashchange", function () {
    scrollHashTargetToTop(true);
  });
})();